export default [
  {
    path: '/:slug/sandbox',
    name: 'sandbox.sandbox',
    component: () => import('../pages/sandbox-page.vue'),
  },
]
